var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuitcaseLineMap = function SvgSuitcaseLineMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5c.46 0 .833.373.833.833V5h4.166c.46 0 .834.373.834.833v10.834c0 .46-.374.833-.834.833h-15a.834.834 0 0 1-.833-.833V5.833c0-.46.373-.833.833-.833h4.167V3.333c0-.46.373-.833.833-.833h5Zm.833 4.167H6.666v9.166h6.667V6.667Zm-10 0v9.166h1.666V6.667H3.333Zm8.333-2.5H8.333V5h3.333v-.833Zm3.333 2.5v9.166h1.667V6.667h-1.667Z",
    fill: "#fff",
    fillOpacity: 0.6
  })));
};
export default SvgSuitcaseLineMap;